module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "WevrTerms&Conditions.32cb3cf7.pdf";